import { Component } from 'react';
import styled from 'styled-components';
import { radius, fontSize } from '../../../../../common/css/setting/variable';
import { FetchingStyle } from '../../css/setting/newsFeedCommonStyle';

interface IProps {
  isFetching: boolean;
  loadMore: () => void;
  clPosition?: number;
  clVmodule?: string;
  clLink?: string;
}

const Wrapper = styled.div`
  padding: 16px;
  border-top: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
`;

const ReadMoreButton = styled.button`
  display: block;
  width: 100%;
  padding: 16px 0; /* buttonコンポーネントより縦幅広め */
  font-size: ${fontSize.px14};
  font-weight: bold;
  color: ${props => props.theme.news.palette.btn_simple_text_common};
  text-decoration: none;
  background-color: ${props => props.theme.news.palette.btn_simple_bg_common};
  border: solid 1px ${props => props.theme.news.palette.btn_simple_border_common};
  border-radius: ${radius.middle_common};

  &:hover {
    background-color: ${props => props.theme.news.palette.bg_hover_normal_pc};
  }
`;

const Fetching = styled.div`
  ${FetchingStyle}
`;

export default class FeedLoadMoreButton extends Component<IProps> {
  /**
   *
   */
  public render() {
    const dataClParams = `_cl_vmodule:${this.props.clVmodule ?? 'load'};_cl_link:${this.props.clLink ?? 'auto'};${
      this.props.clPosition !== undefined ? `_cl_position:${this.props.clPosition};` : ''
    }`;
    return (
      // loading時にclass指定でdisplay:noneを指定しているので、classNameを残す(全体のSC化時に検討)
      <Wrapper className="newsFeed_more">
        {this.props.isFetching ? (
          <Fetching />
        ) : (
          <ReadMoreButton onClick={() => this.props.loadMore()} data-cl-params={dataClParams}>
            もっと見る
          </ReadMoreButton>
        )}
      </Wrapper>
    );
  }
}
